import { useState, useEffect } from "react";
import React from "react";
import useApi from "../../hooks/useApi";
import ExpiringPolicies from "../policies/ExpiringPolicies";
import { useQuery } from "react-query";
import Chart from "react-apexcharts";

const AdminDashboard = () => {
  const [chartData, setChartData] = useState({
    options: {
      chart: {
        id: "apexchart-policies",
      },
      xaxis: {
        categories: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
      },
    },
    series: [
      // {
      //   name: "New Policies",
      //   type: "line",
      //   data: [30, 40, 35, 50, 49, 60, 70, 91, 125],
      // },
      // {
      //   name: "Expired Policies",
      //   type: "column",
      //   data: [3, 4, 5, 0, 9, 6, 0, 9, 12],
      // },
      // {
      //   name: "Renewed Policies",
      //   type: "column",
      //   data: [3, 4, 3, 0, 4, 6, 0, 1, 12],
      // },
    ],
    optionsRadial: {
      plotOptions: {
        radialBar: {
          startAngle: -135,
          endAngle: 225,
          hollow: {
            margin: 0,
            size: "70%",
            background: "#fff",
            image: undefined,
            imageOffsetX: 0,
            imageOffsetY: 0,
            position: "front",
            dropShadow: {
              enabled: true,
              top: 3,
              left: 0,
              blur: 4,
              opacity: 0.24,
            },
          },
          track: {
            background: "#fff",
            strokeWidth: "67%",
            margin: 0, // margin is in pixels
            dropShadow: {
              enabled: true,
              top: -3,
              left: 0,
              blur: 4,
              opacity: 0.35,
            },
          },

          dataLabels: {
            showOn: "always",
            name: {
              offsetY: -20,
              show: true,
              color: "#888",
              fontSize: "0.8rem",
            },
            value: {
              formatter: function (val) {
                return val;
              },
              color: "#111",
              fontSize: "1rem",
              show: true,
            },
          },
        },
      },
      fill: {
        type: "gradient",
        gradient: {
          shade: "dark",
          type: "horizontal",
          shadeIntensity: 0.1,
          gradientToColors: ["red"],
          // inverseColors: true,
          opacityFrom: 1,
          opacityTo: 1,
          stops: [0, 5],
        },
      },
      stroke: {
        lineCap: "round",
      },
      labels: ["Expiring (%)"],
    },
    seriesRadial: [],
    seriesRadialActive: [],
    seriesRadialDormant: [],
    optionsRadialDormant: {
      plotOptions: {
        radialBar: {
          startAngle: -135,
          endAngle: 225,
          hollow: {
            margin: 0,
            size: "70%",
            background: "#fff",
            image: undefined,
            imageOffsetX: 0,
            imageOffsetY: 0,
            position: "front",
            dropShadow: {
              enabled: true,
              top: 3,
              left: 0,
              blur: 4,
              opacity: 0.24,
            },
          },
          track: {
            background: "#fff",
            strokeWidth: "67%",
            margin: 0, // margin is in pixels
            dropShadow: {
              enabled: true,
              top: -3,
              left: 0,
              blur: 4,
              opacity: 0.35,
            },
          },

          dataLabels: {
            showOn: "always",
            name: {
              offsetY: -20,
              show: true,
              color: "#888",
              fontSize: "0.8rem",
            },
            value: {
              formatter: function (val) {
                return val;
              },
              color: "#111",
              fontSize: "1rem",
              show: true,
            },
          },
        },
      },
      fill: {
        type: "gradient",
        gradient: {
          shade: "dark",
          type: "horizontal",
          shadeIntensity: 0.1,
          gradientToColors: ["blue"],
          inverseColors: true,
          opacityFrom: 1,
          opacityTo: 1,
          stops: [0, 5],
        },
      },
      stroke: {
        lineCap: "round",
      },
      labels: ["Customers (%)"],
    },
    optionsRadialActive: {
      plotOptions: {
        radialBar: {
          startAngle: -135,
          endAngle: 225,
          hollow: {
            margin: 0,
            size: "70%",
            background: "#fff",
            image: undefined,
            imageOffsetX: 0,
            imageOffsetY: 0,
            position: "front",
            dropShadow: {
              enabled: true,
              top: 3,
              left: 0,
              blur: 4,
              opacity: 0.24,
            },
          },
          track: {
            background: "#fff",
            strokeWidth: "67%",
            margin: 0, // margin is in pixels
            dropShadow: {
              enabled: true,
              top: -3,
              left: 0,
              blur: 4,
              opacity: 0.35,
            },
          },

          dataLabels: {
            showOn: "always",
            name: {
              offsetY: -20,
              show: true,
              color: "#888",
              fontSize: "0.8rem",
            },
            value: {
              formatter: function (val) {
                return val;
              },
              color: "#111",
              fontSize: "1rem",
              show: true,
            },
          },
        },
      },
      fill: {
        type: "gradient",
        gradient: {
          shade: "dark",
          type: "horizontal",
          shadeIntensity: 0.1,
          gradientToColors: ["gold"],
          inverseColors: true,
          opacityFrom: 1,
          opacityTo: 1,
          stops: [0, 100],
        },
      },
      stroke: {
        lineCap: "round",
      },
      labels: ["Customers (%)"],
    },
  });

  const { api, auth } = useApi();

  const getPolicies = async () => {
    try {
      const url = `/policies/policy-items/stats`;
      const { data } = await api.list(url);
      // console.log(data);
      const expiringPercent =
        (data?.count?.expiring / data?.count.active) * 100;
      const activeCustomerPercent =
        (data?.customers?.active / data?.customers?.total) * 100;
      const dormantCustomerPercent =
        (data?.customers?.dormant / data?.customers?.total) * 100;
      // console.log(dormantCustomerPercent);

      const series = [
        {
          name: "New Policies",
          type: "line",
          data: data?.trend?.new || [],
        },
        {
          name: "Policy Expiring",
          type: "column",
          data: data?.trend?.expired || [],
        },
        {
          name: "Renewed Policies",
          type: "column",
          data: data?.trend?.renewed || [],
        },
      ];

      setChartData({
        ...chartData,
        seriesRadial: [expiringPercent.toFixed(2)],
        seriesRadialActive: [activeCustomerPercent.toFixed(2)],
        seriesRadialDormant: [dormantCustomerPercent.toFixed(2)],
        series: series,
      });
      return data;
    } catch (error) {
      throw new Error("failed to fetch records");
    }
  };

  const { data: policyCount } = useQuery(
    ["countPolicyItems", auth],
    ({ queryKey }) => getPolicies()
  );

  return (
    <section id="content" className="content">
      <div className="content__header content__boxed overlapping">
        <div className="content__wrap">
          {/* <!-- Page title and information --> */}
          <h1 className="page-title mb-2">Dashboard</h1>
          <h2 className="h5">Welcome back to the Dashboard.</h2>
          <p>
            {/* Scroll down to see quick links and overviews of your Server, To do
            list
            <br />
            Order status or get some Help using Nifty. */}
          </p>
          {/* <!-- END : Page title and information --> */}
        </div>
      </div>
      <div className="content__boxed">
        <div className="content__wrap">
          <div className="row">
            <div className="col-xl-7 mb-3 mb-xl-0">
              <div className="card h-100">
                {/* <!-- Network - Area Chart --> */}
                <div
                  className="card-body py-0"
                  // style="height: 250px; max-height: 275px"
                >
                  <Chart
                    options={chartData.options}
                    series={chartData.series}
                    // type={["line"]}
                  />
                </div>
                {/* <!-- END : Network - Area Chart --> */}

                <div className="card-body mt-4"></div>
              </div>
            </div>
            <div className="col-xl-5">
              <div className="card mb-3">
                <div className="card-body text-center">
                  <div className="d-flex align-items-center">
                    <div className="flex-shrink-0 p-3">
                      <div className="h3 display-3">
                        <Chart
                          options={chartData.optionsRadial}
                          series={chartData.seriesRadial}
                          type="radialBar"
                          // width="280"
                        />
                      </div>
                    </div>
                    <div className="flex-grow-1 text-center ms-3">
                      {/* <!-- Social media statistics --> */}
                      <div className="mt-4 pt-3 d-flex justify-content-around">
                        <div className="text-center">
                          <h4 className="mb-1">
                            {policyCount?.count?.active || 0}
                          </h4>
                          <small className="text-muted">Active</small>
                        </div>
                        <div className="text-center">
                          <h4 className="mb-1">
                            {policyCount?.count?.renewal || 0}
                          </h4>
                          <small className="text-muted">Renewed</small>
                        </div>
                        <div className="text-center">
                          <h4 className="mb-1">
                            {policyCount?.count?.expired || 0}
                          </h4>
                          <small className="text-muted">Expired</small>
                        </div>
                      </div>
                      {/* <!-- END : Social media statistics --> */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  {/* <!-- Tile - HDD Usage --> */}
                  <div className="card bg-success text-white overflow-hidden mb-3">
                    <div className="p-3 pb-2">
                      <h5 className="mb-3">
                        <i className="demo-psi-data-storage text-reset text-opacity-75 fs-3 me-2"></i>
                        Active Customers
                      </h5>
                      <ul className="list-group list-group-borderless">
                        <li className="list-group-item p-0 text-reset d-flex justify-content-between align-items-start">
                          <div className="me-auto">Total</div>
                          <span className="fw-bold">
                            {policyCount?.customers?.active || 0}
                          </span>
                        </li>
                      </ul>
                    </div>

                    {/* <!-- Area Chart --> */}
                    <div className="d-flex justify-content-center">
                      <Chart
                        options={chartData.optionsRadialActive}
                        series={chartData.seriesRadialActive}
                        type="radialBar"
                        width="250"
                      />
                    </div>
                    {/* <!-- END : Area Chart --> */}
                  </div>
                  {/* <!-- END : Tile - HDD Usage --> */}
                </div>
                <div className="col-sm-6">
                  {/* <!-- Tile - Earnings --> */}
                  <div className="card bg-info text-white overflow-hidden mb-3">
                    <div className="p-3 pb-2">
                      <h5 className="mb-3">
                        <i className="demo-psi-coin text-reset text-opacity-75 fs-2 me-2"></i>
                        Dormant Customer
                      </h5>
                      <ul className="list-group list-group-borderless">
                        <li className="list-group-item p-0 text-reset d-flex justify-content-between align-items-start">
                          <div className="me-auto">Total</div>
                          <span className="fw-bold">
                            {policyCount?.customers?.dormant || 0}
                          </span>
                        </li>
                      </ul>
                    </div>

                    {/* <!-- Line Chart --> */}
                    <div className="d-flex justify-content-center">
                      <Chart
                        options={chartData.optionsRadialDormant}
                        series={chartData.seriesRadialDormant}
                        type="radialBar"
                        width="250"
                      />
                    </div>
                    {/* <!-- END : Line Chart --> */}
                  </div>
                  {/* <!-- END : Tile - Earnings --> */}
                </div>
              </div>

              {/* <!-- Simple state widget --> */}

              {/* <!-- END : Simple state widget --> */}
            </div>
          </div>
        </div>
      </div>
      <ExpiringPolicies />
    </section>
  );
};

export default AdminDashboard;
